import { Box, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { trainwellColor } from "src/theme/themePrimitives";
import { getAvatarLetters } from "../utils/teamUtils";
import { useButtonStore } from "./ButtonState";
import { StyledTextField } from "./FreeboardingTextField";
import { TeamAvatar } from "./TeamAvatar";
import { useTeamState } from "./teams/TeamState";

const TeamNameInputField = () => {
  // Stores the current value of the input field.
  const { teamName, setTeamName } = useTeamState();
  // Stores the letters to display in the avatar.
  const [avatarLetters, setAvatarLetters] = useState("");
  // Ref for the input field.
  const inputRef = useRef<HTMLDivElement>(null);
  // Stores the height of the input field to make the avatar the same height.
  const [inputHeight, setInputHeight] = useState(0);
  const setButtonEnabled = useButtonStore((state) => state.setButtonEnabled);

  useEffect(() => {
    const letters = getAvatarLetters(teamName || "");
    setAvatarLetters(letters);
  }, [teamName]);

  useEffect(() => {
    // Calculate input height after the component mounts
    if (inputRef.current) {
      setInputHeight(inputRef.current.offsetHeight);
    }
  }, []);

  // Updates the teamName state when the input field changes, and limits the size to 40 characters.
  const handleChange = (event: any) => {
    const value = event.target.value;
    if (value.length <= 0) {
      setTeamName(value);
      setButtonEnabled(false);
    } else if (value.length <= 40) {
      setTeamName(value);
      setButtonEnabled(true);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}
      >
        <TeamAvatar
          sx={{
            height: inputHeight,
            width: inputHeight,
          }}
        >
          {avatarLetters}
        </TeamAvatar>
        <StyledTextField
          fullWidth
          placeholder="Team Name"
          value={teamName}
          onChange={handleChange}
          slotProps={{
            htmlInput: {
              maxLength: 40,
            },
          }}
          inputRef={inputRef}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
        <Typography variant="body2" color={trainwellColor.neutral6}>
          {teamName?.length || 0}/40
        </Typography>
      </Box>
    </Box>
  );
};

export default TeamNameInputField;
